// Mock data for IN SMART MEDIA website

export const companyInfo = {
  name: "IN SMART MEDIA",
  tagline: "YOUR COMPLETE ADVERTISING & BRANDING SOLUTION",
  description: "A trusted, experienced and result-driven advertising agency in Solapur. We deliver complete offline + digital marketing solutions under one roof.",
  experience: "17+ Years",
  campaigns: "500+",
  services: "50+",
  address: "Near ESI Hospital, Hotagi Road, Solapur",
  phone: ["8625011717", "9765562856"],
  whatsapp: "918625011717",
  email: "insmartmedia.advt@gmail.com",
  emailSecondary: "yogeshwagh@insmartmedia.com",
  website: "www.insmartmedia.com",
  socialMedia: {
    facebook: "https://www.facebook.com/share/14WortzwTQT/",
    instagram: "https://www.instagram.com/insmartmedia?igsh=MTViaWxoamE1c2NmdQ=="
  }
};

export const directorInfo = {
  directors: [
    {
      title: "Founder & Director",
      experience: "23+ Years",
      name: "Yogesh Wagh",
      designation: "Founder & Director",
      image: "https://customer-assets.emergentagent.com/job_insmart-media/artifacts/5jhp57et_file_00000000313472069c1ff21f16b8f9d8.png",
      description: "A visionary leader with 23+ years of rich experience in the advertising and marketing industry. With a deep understanding of both traditional and digital media landscapes, Yogesh has successfully led over 500 brand campaigns, transforming businesses from small startups to established market leaders.",
      expertise: [
        "Strategic Brand Development",
        "Integrated Marketing Communications",
        "Digital Transformation",
        "Client Relationship Management",
        "Creative Campaign Direction",
        "Market Analysis & Consumer Insights"
      ]
    },
    {
      title: "Co-Director",
      experience: "24+ Years",
      name: "Siddharam Wagh",
      designation: "Director & Media Strategy Head",
      image: "https://customer-assets.emergentagent.com/job_insmart-media/artifacts/hzyqqifx_WhatsApp%20Image%202026-02-25%20at%2015.49.31.jpeg",
      description: "Siddharam Wagh is a seasoned media and advertising professional with over 24 years of experience in the print media industry. Throughout his career, he has worked with some of India's leading media organizations including The Times of India Group, Dainik Bhaskar Group, and Sakal Media Group, where he handled diverse responsibilities in advertising and media management.",
      expertise: [
        "Client Relations & Management",
        "Media Planning & Buying",
        "Client Profiling & Analysis",
        "Budget Optimization Strategies",
        "Regional Market Strategy",
        "Print & Digital Media Integration"
      ],
      additionalInfo: "He possesses strong expertise in Client Relations, Media Planning, Client Profiling, Budget Optimization, and Regional Market Strategy. Currently serving as the Director of IN SMART MEDIA, he focuses on delivering strategic advertising solutions by combining traditional and modern media platforms. With his deep industry knowledge and strong professional network, he continues to create impactful and result-driven campaigns for a wide range of clients."
    }
  ],
  philosophy: "Advertising is not an expense... It is an investment in growth. Our founders believe in creating meaningful connections between brands and consumers through data-driven strategies, creative excellence, and measurable results.",
  achievements: [
    "Pioneered advertising solutions in Solapur region",
    "Built successful campaigns for 500+ brands",
    "Established partnerships with leading media platforms",
    "Mentored teams delivering innovative advertising solutions",
    "Recognized for excellence in integrated marketing campaigns"
  ]
};

export const services = [
  {
    id: 1,
    name: "E-Rickshaw Branding",
    description: "Mobile advertising that moves through high-traffic areas, ensuring maximum visibility across the city",
    icon: "Truck",
    features: [
      "High visibility in local markets",
      "Cost-effective mobility advertising",
      "Reaches diverse audience segments",
      "Perfect for local business promotion"
    ],
    benefits: "Low-budget, high-impact mobile advertising solution"
  },
  {
    id: 2,
    name: "Street Hoarding Advertising",
    description: "Strategic placement of large-format hoardings in high-traffic locations for maximum brand exposure",
    icon: "Building2",
    features: [
      "Premium location selection",
      "24/7 brand visibility",
      "Large-format impact",
      "Long-term brand recall"
    ],
    benefits: "Guaranteed visibility with strategic positioning"
  },
  {
    id: 3,
    name: "Holography Advertising",
    description: "Innovative 3D holographic displays that create memorable brand experiences and capture attention",
    icon: "Sparkles",
    features: [
      "Cutting-edge technology",
      "Unique visual impact",
      "High engagement rates",
      "Memorable brand experience"
    ],
    benefits: "Stand out with futuristic advertising technology"
  },
  {
    id: 4,
    name: "Tricycle Branding",
    description: "Localized mobile advertising perfect for reaching neighborhood markets and community events",
    icon: "Bike",
    features: [
      "Hyperlocal market penetration",
      "Flexible route coverage",
      "Budget-friendly option",
      "Community-level engagement"
    ],
    benefits: "Grassroots marketing for local businesses"
  },
  {
    id: 5,
    name: "FM / Radio Advertising",
    description: "Reach thousands of listeners with compelling audio messages during peak listening hours",
    icon: "Radio",
    features: [
      "Wide audience reach",
      "Prime time slots available",
      "Professional audio production",
      "Repeated brand messaging"
    ],
    benefits: "Audio branding with massive local reach"
  },
  {
    id: 6,
    name: "Road Arch - Welcome Gate Branding",
    description: "Grand entrance branding that creates lasting impressions at city entry points and major locations",
    icon: "Landmark",
    features: [
      "Prominent positioning",
      "Large-scale visibility",
      "Landmark advertising",
      "Creates city-level awareness"
    ],
    benefits: "Monumental branding for maximum impact"
  },
  {
    id: 7,
    name: "Leaflet Printing & Distribution",
    description: "Targeted distribution of professionally designed leaflets to reach your specific audience",
    icon: "FileText",
    features: [
      "Professional design & printing",
      "Targeted distribution",
      "Direct customer engagement",
      "Measurable response rates"
    ],
    benefits: "Direct marketing with tangible results"
  },
  {
    id: 8,
    name: "Mobile Van / LED Van Branding",
    description: "Dynamic mobile advertising with LED displays for maximum visibility and flexible routing",
    icon: "TruckIcon",
    features: [
      "LED screen technology",
      "Customizable routes",
      "Audio-visual impact",
      "Event-based promotion"
    ],
    benefits: "Moving billboards with digital capabilities"
  },
  {
    id: 9,
    name: "Social Media Local Star Reels",
    description: "Create viral-worthy social media content that showcases your brand to local audiences",
    icon: "Instagram",
    features: [
      "Professional content creation",
      "Local influencer partnerships",
      "High engagement potential",
      "Platform optimization"
    ],
    benefits: "Digital visibility with local star power"
  },
  {
    id: 10,
    name: "Newspaper Advertising",
    description: "Strategic newspaper ads in leading publications for credible and wide-reaching brand messaging",
    icon: "Newspaper",
    features: [
      "Multiple publication options",
      "Credible media platform",
      "Targeted audience selection",
      "Various ad sizes available"
    ],
    benefits: "Trusted traditional media reach"
  },
  {
    id: 11,
    name: "Local TV Channel Advertising",
    description: "Television commercials on local channels for visual storytelling and brand recognition",
    icon: "Tv",
    features: [
      "Visual brand storytelling",
      "Prime time advertising",
      "Professional production",
      "Local market dominance"
    ],
    benefits: "Audio-visual impact on television"
  },
  {
    id: 12,
    name: "Google Business Photography",
    description: "Professional photography services to enhance your Google Business profile and online presence",
    icon: "Camera",
    features: [
      "Professional photography",
      "Google Business optimization",
      "360-degree virtual tours",
      "Enhanced online visibility"
    ],
    benefits: "Boost online discoverability and credibility"
  }
];

export const whyChooseUs = [
  {
    title: "Market Reach & Smart Targeting",
    description: "We help businesses capture the right audience with data-driven strategies",
    icon: "Target"
  },
  {
    title: "Creative Branding",
    description: "Powerful designs + perfect messaging = higher customer attention",
    icon: "Palette"
  },
  {
    title: "Fast & Measurable Growth",
    description: "Quick promotions, real-time performance tracking & guaranteed visibility",
    icon: "TrendingUp"
  },
  {
    title: "17+ Years of Excellence",
    description: "Trusted expertise delivering successful campaigns across diverse industries",
    icon: "Award"
  },
  {
    title: "Complete Solutions",
    description: "50+ advertising services ensuring low-budget, high-impact campaigns for every business",
    icon: "Package"
  },
  {
    title: "Proven Track Record",
    description: "500+ successful brand campaigns executed with measurable results",
    icon: "CheckCircle2"
  }
];

export const clients = [
  "Banks & Financial Institutions",
  "Hospitals & Healthcare Centers",
  "Educational Institutions",
  "Retail Businesses",
  "Real Estate Developers",
  "Hospitality Industry",
  "Manufacturing Companies",
  "Service Providers"
];

export const smartPrinciples = {
  title: "SMART Advertising Principles",
  items: [
    {
      letter: "S",
      word: "Specific",
      description: "Clearly defined goals and target audience for every campaign"
    },
    {
      letter: "M",
      word: "Measurable",
      description: "Data-driven approach with trackable metrics and KPIs"
    },
    {
      letter: "A",
      word: "Achievable",
      description: "Realistic objectives aligned with your budget and resources"
    },
    {
      letter: "R",
      word: "Relevant",
      description: "Campaigns tailored to your business goals and market needs"
    },
    {
      letter: "T",
      word: "Time-bound",
      description: "Structured timelines ensuring timely delivery and results"
    }
  ]
};

// Form submission handler (connects to backend and WhatsApp)
export const submitInquiry = async (formData) => {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
  try {
    const response = await fetch(`${BACKEND_URL}/api/inquiries`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    
    const data = await response.json();
    
    if (response.ok) {
      // Send inquiry to WhatsApp
      sendToWhatsApp(formData);
      
      return { success: true, message: data.message };
    } else {
      throw new Error(data.message || 'Failed to submit inquiry');
    }
  } catch (error) {
    console.error('Error submitting inquiry:', error);
    return { success: false, message: 'Failed to submit inquiry. Please try again.' };
  }
};

// WhatsApp Integration
export const sendToWhatsApp = (formData) => {
  const whatsappNumber = '918625011717'; // WhatsApp Business number
  
  // Format the message with inquiry details
  const message = `*New Website Inquiry - IN SMART MEDIA*

📝 *Inquiry Details:*

👤 *Name:* ${formData.name}
📧 *Email:* ${formData.email}
📱 *Phone:* ${formData.phone}

🏢 *Business Type:* ${formData.businessType || 'Not specified'}
🎯 *Service Interest:* ${formData.serviceInterest || 'Not specified'}
💰 *Budget Range:* ${formData.budgetRange || 'Not specified'}

💬 *Message:*
${formData.message}

---
Sent from www.insmartmedia.com`;

  // Encode the message for URL
  const encodedMessage = encodeURIComponent(message);
  
  // Create WhatsApp link
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
  
  // Open WhatsApp in new tab
  window.open(whatsappUrl, '_blank');
};
